module.exports = __webpack_public_path__ + "yeni fransa mutfak 1.jpg?6d25720f98bed0be506470bed5b8b81d";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni fransa mutfak 1.jpg
// module id = 372
// module chunks = 0